angular.module('swapick')
.controller('LostPasswordCtrl', LostPasswordCtrl);

function LostPasswordCtrl ($auth, $rootScope, authService, $ionicSideMenuDelegate, DataService, clientId, clientSecret, $http, Entities, $ionicLoading) {

    this.credentials = {};
    this.errors = false;
    this.success = false;

    this.recoverPassword = () => {
        console.log(1, this.credentials)
        return DataService.lostPassword.post({
            username : this.credentials.username
        })
        .then(resp => {
            this.success = true;
            this.error = false;
        })
        .catch(err => {
            this.success = false;
            this.error = err.status;  
        })
    }

  
  
}





// WEBPACK FOOTER //
// ./src/controllers/lost-password-controller.js